import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Template } from '../../../@types/domain';
import { getMyActiveTemplates } from '../../../services/templates';

function useGetTemplates(
  useQueryOptions?: UseQueryOptions<Template[], Error, Template[]>
) {
  return useQuery<Template[], Error, Template[]>(
    ['templates', 'getMyActiveTemplates'],
    () => getMyActiveTemplates(),
    useQueryOptions
  );
}

export default useGetTemplates;
